// QAS in the NEW-generation subscription "neurocare OS Qas" (Azure migration).
export const environment = {
  production: true,
  apiURL:
    'https://backend-b3e1344d7dd2-acgsbjfzhxhuf0a0.z01.azurefd.net/public-api',
  appInsights: {
    instrumentationKey: '91b1b6a1-513b-4134-986b-a210354fe44c',
  },
  useAppInsights: true,
};
